import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getSalaries } from "api/Finances";


export const useSalaries = (search: string) => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['salaries', search],
        () => {
            return getSalaries({
                search: search,
            });
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
    }
    );

    return {
        data,
        isLoading,
    };
};
